import api from "../../services/api";

export default function SheetPreview({ jobId, width = 800, height = 500 }) {
  return (
    <div className="mt-3 text-center">
      <img
        src={api.getLayoutingSheetPreview(jobId)}
        style={{ width, height, objectFit: "contain" }}
        alt="preview"
      />
    </div>
  );
}
